import React, { useState } from "react";
import * as Glob from "../../Globale";

export const AlertDialogContext = React.createContext({
    Dialog: new Glob.CDialog(),
    ShowDialog: (Title: string, Content: string, Type: Glob.DialogType) => {},
    HideDialog: () => {}
});

export const AlertDialogProvider = (props: React.PropsWithChildren<{}>) => {
    const [Dialog, setDialog] = useState(new Glob.CDialog());

    const contextValue = {
        Dialog,
        ShowDialog: (Title: string, Content: string, Type: Glob.DialogType) => {
            setDialog({ Open: true, Title, Content, Type });
        },
        HideDialog: () => setDialog({ ...new Glob.CDialog(), Type: Dialog.Type })
    };

    return <AlertDialogContext.Provider value={contextValue}>{props.children}</AlertDialogContext.Provider>;
};



// WEBPACK FOOTER //
// ./src/inar2/providers/AlertDialogProvider.tsx